export const handMatrixActions = {
  UPDATE_STRATEGY_FOR_EACH_COMBOS: 'UPDATE_STRATEGY_FOR_EACH_COMBOS',
  UPDATE_SUITS_FOR_FILTER: 'UPDATE_SUITS_FOR_FILTER',
  UPDATE_DECISION_FILTER: 'UPDATE_DECISION_FILTER',
  CHANGE_VIEW: 'CHANGE_VIEW',
  CHANGE_CLICKED_HAND_ITEM: 'CHANGE_CLICKED_HAND_ITEM',
  REFRESH_HAND_MATRIX: 'REFRESH_HAND_MATRIX',
  UPDATE_COMBO_WITH_INDEX: 'UPDATE_COMBO_WITH_INDEX'
}
